<template>
  <div class="calico-date-picker-wrapper">
    <h2 class="heading--medium">
      Date Picker Example
    </h2>
    <div class="calico-field-container">
      <CalicoDatePicker v-model="selectedDate" />
    </div>
    <p class="label--medium">
      Selected Date: {{ selectedDate }}
    </p>
  </div>
</template>
<script>
import CalicoDatePicker from "@/components/calico/datePicker";

export default {
  name: "DatePickerView",
  components: {
    CalicoDatePicker,
  },
  data() {
    return {
      selectedDate: "",
    };
  },
};
</script>

<style lang="scss" scoped>
.calico-date-picker-wrapper {
  @include stack-space($space-none);
  justify-content: center;
  align-items: center;
  
  .calico-field-container {
    width: 30%; 
    max-width: 500px; 
    min-width: 300px; 
    @include stack-space($space-none);
  }
}
</style>